export const version = 'v5.8.0';
export const buildDate = '2026-09-09T00:35:23.043Z';
export const commitHash = 'c4973e7';